import {
  Select,
  FormGroup,
  Paper,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Button,
  MenuItem,
  Table,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import { Dialog } from "@mui/material";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";
import { CSVLink } from "react-csv";
import DateCalc, { filterQuotes, getconvdate, removeDuplicates } from "./date";
import { gethotdate } from "./date";
import { DataGrid } from "@mui/x-data-grid";
import { preventDoubleClick } from "./preventDC.js";
import {
  updateTripflightdata,
  fetchConvertedTripsbyTL,
  fetchhottripsTL,
  fetchTripbyId,
  updateTripdata,
  fetchTripsbyStatus,
  fetchConvertedTripsOnly,
  getWAdata,
  fetchtripstatusoftripids,
  fetchbookertripsTL1,
  fetchbookertripsTL2,
  fetchbookertripsTL3,
  fetchbookertripsTL4,
  fetchbookertripsTL6,
  getprojectionfromserver,
  fetchQuotebyId,
  gethighprofitsearch,
  updatequoteData,
  addWAreport,
  updatesuperhot,
  getactiveluxury,
  gettlreport,
  addtlreport,
  updatetlreport,
  gethottrips,
  newsearchQEbyDate,
  fetchbyholdops
} from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(30),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formgroup: {
    justifyContent: "center",
  },
  textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(15),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const TLHome = () => {
  const classes = useStyles();
  const { cuser, role, employeelist, destinationlist, loading } = GetRole();
  const [convdata, setconvdata] = useState([]);
  const [eData, seteData] = useState([]);
  const [opsData, setopsData] = useState([]);
  const [wareportData, setwareportData] = useState([]);
  const [waData, setwaData] = useState({});
  const [filterData, setfilterData] = useState([]);
  const [emp, setemp] = useState([]);
  const [hotdata, sethotdata] = useState([]);
  const [hodata, sethodata] = useState([]);
  const [bookerdata, setbookerdata] = useState([]);
  const [profittrips, setprofittrips] = useState([]);
  const [luxurytrip, setluxurytrip] = useState([]);
  const width = window.innerWidth - 200;
  const [selection, setselection] = useState([]);
  const [selection2, setselection2] = useState([]);
  const [selection3, setselection3] = useState([]);
  const [selection4, setselection4] = useState([]);
  const [selection5, setselection5] = useState([]);
  const [selection6, setselection6] = useState([]);
  const [selection8, setselection8] = useState([]);
  const [listQEdata, setlistQEdata] = useState([]);
  const [searchData, setsearchData] = useState([]);
  const [searchData2, setsearchData2] = useState({});
  const [reportData, setreportData] = useState(false);
  const [projectionData, setprojectionData] = useState([]);
  const [hotlist, sethotlist] = useState([]);
  const [tlData, settlData] = useState([]);
  const [open, setopen] = useState(false);
  const [open2, setopen2] = useState(false);
  const [splist, setsplist] = useState(false);

  const calculateColumnWidth = (rows, field, minWidth = 80) => {
    const maxContentLength = Math.max(
      ...rows.map((row) => (row[field] ? row[field].toString().length : 0)),
    );
    return Math.max(minWidth, maxContentLength * 10); // 10px per character
  };

  const fcolumns = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 1,
    },

    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "transfer_state",
      headerName: "State",
      width: width / 12,
    },
    {
      field: "tcs",
      headerName: "TCS",
      width: width / 12,
    },
    {
      field: "flight_status",
      headerName: "Flight Status",
      width: width / 12,
    },
    {
      field: "comment1",
      headerName: "TL Comment 1",
      width: (width / 12) * 2,
    },
    {
      field: "comment1_date",
      headerName: "Comment 1 Date",
      width: width / 12,
    },
    {
      field: "comment2",
      headerName: "TL Comment 2",
      width: (width / 12) * 2,
    },
    {
      field: "comment2_date",
      headerName: "Comment 2 Date",
      width: width / 12,
    },
    {
      field: "comment3",
      headerName: "TL Comment 3",
      width: (width / 12) * 2,
    },
    {
      field: "comment3_date",
      headerName: "Comment 3 Date",
      width: width / 12,
    },
    {
      field: "jc_date",
      headerName: "JC Date",
      width: width / 12,
    },
    {
      field: "accepted_date",
      headerName: "Accepted Date",
      width: width / 12,
    },
  ];

  const fcolumns2 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      resizable: true,
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 1,
      resizable: true,
    },

    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
      resizable: true,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: width / 12,
      resizable: true,
    },
    {
      field: "verified",
      headerName: "Verified",
      width: width / 12,
      resizable: true,
    },
    {
      field: "hot_date",
      headerName: "Hot Marked",
      width: width / 12,
      resizable: true,
    },
    {
      field: "pax",
      headerName: "Pax",
      width: (width / 12) * 0.5,
      resizable: true,
    },
    {
      field: "comment1",
      headerName: "TL Comment 1",
      width: (width / 12) * 3,
      resizable: true,
    },
    {
      field: "comment1_date",
      headerName: "Comment 1 Date",
      width: width / 12,
      resizable: true,
    },
    {
      field: "comment2",
      headerName: "TL Comment 2",
      width: (width / 12) * 3,
      resizable: true,
    },
    {
      field: "comment2_date",
      headerName: "Comment 2 Date",
      width: width / 12,
      resizable: true,
    },
    {
      field: "comment3",
      headerName: "TL Comment 3",
      width: (width / 12) * 3,
      resizable: true,
    },
    {
      field: "comment3_date",
      headerName: "Comment 3 Date",
      width: width / 12,
      resizable: true,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: (width / 12) * 1,
      resizable: true,
    },
  ];

  const fcolumns9 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      resizable: true,
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 1,
      resizable: true,
    },

    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
      resizable: true,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: width / 12,
      resizable: true,
    },
    {
      field: "team_leader",
      headerName: "TL",
      width: width / 12,
      resizable: true,
    },
   
    {
      field: "comment1",
      headerName: "TL Comment 1",
      width: (width / 12) * 3,
      resizable: true,
    },
    {
      field: "comment1_date",
      headerName: "Comment 1 Date",
      width: width / 12,
      resizable: true,
    },
    {
      field: "comment2",
      headerName: "TL Comment 2",
      width: (width / 12) * 3,
      resizable: true,
    },
    {
      field: "comment2_date",
      headerName: "Comment 2 Date",
      width: width / 12,
      resizable: true,
    },
    {
      field: "comment3",
      headerName: "TL Comment 3",
      width: (width / 12) * 3,
      resizable: true,
    },
    {
      field: "comment3_date",
      headerName: "Comment 3 Date",
      width: width / 12,
      resizable: true,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: (width / 12) * 1,
      resizable: true,
    },
  ];

  const wacolumns = [
    {
      field: "employee_name",
      headerName: "Name",
      width: (width / 12) * 2,
      resizable: true,
    },

    {
      field: "date",
      headerName: "Date",
      width: (width / 12) * 2,
      resizable: true,
    },
    {
      field: "count",
      headerName: "Trip check Count",
      width: width / 12,
      resizable: true,
    },
     {
      field: "manager",
      headerName: "Report By",
      width: width / 12,
      resizable: true,
    },
    {
      field: "note",
      headerName: "Report Note",
      width: (width / 12) * 6,
      resizable: true,
    },
  ];

  const fcolumns22 = [
    {
      field: "report_date",
      headerName: "Report Date",
      width: (width / 12) * 1.5,
      //width: calculateColumnWidth(tripdatalistdisplay7, "report_date"),
      resizable: true,
    },
    {
      field: "sp_name",
      headerName: "Trip Owner",
      width: (width / 12) * 1,
      resizable: true,
    },
    {
      field: "trip_id",
      headerName: " Trip Details",
      width: (width / 12) * 2,
      cellClassName: "gridcell",
      resizable: true,
      //headerAlign:"center"
    },
    {
      field: "expected_date",
      headerName: "Exp. Date",
      width: (width / 12) * 1.5,
      resizable: true,
    },
    {
      field: "trip_status",
      headerName: "Status",
      width: (width / 12) * 1.5,
      resizable: true,
    },
    {
      field: "tl_note",
      headerName: "TL Note",
      width: (width / 12) * 4,
      resizable: true,
    },
  ];

  const headershot = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Owner", key: "trip_owner" },
    { label: "Revenue", key: "verified" },
    { label: "Conv Date", key: "hot_date" },
    { label: "Pax", key: "pax" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Comment 1", key: "comment1" },
    { label: "Comment 1 Date", key: "comment1_date" },
    { label: "Comment 2", key: "comment2" },
    { label: "Comment 2 Date", key: "comment2_date" },
    { label: "Comment 3", key: "comment3" },
    { label: "Comment 3 Date", key: "comment3_date" },
    { label: "Destination", key: "dest" },
  ];

  const headersho = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Owner", key: "trip_owner" },
    { label: "TL", key: "team_leader" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Comment 1", key: "comment1" },
    { label: "Comment 1 Date", key: "comment1_date" },
    { label: "Comment 2", key: "comment2" },
    { label: "Comment 2 Date", key: "comment2_date" },
    { label: "Comment 3", key: "comment3" },
    { label: "Comment 3 Date", key: "comment3_date" },
    { label: "Destination", key: "dest" },
  ];

  const headersqe = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Owner", key: "trip_owner" },
    { label: "Quote Id", key: "quote_id" },
    { label: "Trip Status", key: "trip_status" },
    { label: "Created At", key: "created_date" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Comment 1", key: "comment1" },
    { label: "Comment 1 Date", key: "comment1_date" },
    { label: "Comment 2", key: "comment2" },
    { label: "Comment 2 Date", key: "comment2_date" },
    { label: "Comment 3", key: "comment3" },
    { label: "Comment 3 Date", key: "comment3_date" },
    { label: "Destination", key: "dest" },
  ];

  const headershigh = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Quote Id", key: "quote_id" },
    { label: "Name", key: "cust_name" },
    { label: "Owner", key: "trip_owner" },
    { label: "Destination", key: "primary_destination" },
    { label: "Profit", key: "profit" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Comment 1", key: "comment1" },
    { label: "Comment 1 Date", key: "comment1_date" },
    { label: "Comment 2", key: "comment2" },
    { label: "Comment 2 Date", key: "comment2_date" },
    { label: "Comment 3", key: "comment3" },
    { label: "Comment 3 Date", key: "comment3_date" },
  ];

  const fcolumns3 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 1,
    },

    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "why_hot",
      headerName: "Why Hot",
      width: (width / 12) * 0.5,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: width / 12,
    },

    {
      field: "comment1",
      headerName: "TL Comment 1",
      width: (width / 12) * 3,
    },
    {
      field: "comment1_date",
      headerName: "Comment 1 Date",
      width: width / 12,
    },
    {
      field: "comment2",
      headerName: "TL Comment 2",
      width: (width / 12) * 3,
    },
    {
      field: "comment2_date",
      headerName: "Comment 2 Date",
      width: width / 12,
    },
    {
      field: "comment3",
      headerName: "TL Comment 3",
      width: (width / 12) * 3,
    },
    {
      field: "comment3_date",
      headerName: "Comment 3 Date",
      width: width / 12,
    },
  ];

  const fcolumns4 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "quote_id",
      headerName: "Quote Id",
      width: width / 12,
      cellClassName: "gridcell",
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 1,
    },

    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },

    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: width / 12,
    },
    {
      field: "primary_destination",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "profit",
      headerName: "Profit",
      width: width / 12,
    },
    {
      field: "comment1",
      headerName: "TL Comment 1",
      width: (width / 12) * 3,
    },
    {
      field: "comment1_date",
      headerName: "Comment 1 Date",
      width: width / 12,
    },
    {
      field: "comment2",
      headerName: "TL Comment 2",
      width: (width / 12) * 3,
    },
    {
      field: "comment2_date",
      headerName: "Comment 2 Date",
      width: width / 12,
    },
    {
      field: "comment3",
      headerName: "TL Comment 3",
      width: (width / 12) * 3,
    },
    {
      field: "comment3_date",
      headerName: "Comment 3 Date",
      width: width / 12,
    },
  ];

  const fcolumns5 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 1.5,
    },

    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: width / 12,
    },
    {
      field: "verified",
      headerName: "Verified",
      width: width / 12,
    },
    {
      field: "hot_date",
      headerName: "Hot Marked",
      width: width / 12,
    },
    {
      field: "comment1",
      headerName: "Projection 1",
      width: (width / 12) * 2,
    },

    {
      field: "comment2",
      headerName: "Projection 2",
      width: (width / 12) * 2,
    },

    {
      field: "comment3",
      headerName: "Projection 3",
      width: (width / 12) * 2,
    },
  ];

  const fcolumns6 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 1,
    },
    {
      field: "quote_id",
      headerName: "Quote Id",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },

    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: width / 12,
    },
    {
      field: "primary_destination",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "comment1",
      headerName: "TL Comment 1",
      width: (width / 12) * 3,
    },
    {
      field: "comment1_date",
      headerName: "Comment 1 Date",
      width: width / 12,
    },
    {
      field: "comment2",
      headerName: "TL Comment 2",
      width: (width / 12) * 3,
    },
    {
      field: "comment2_date",
      headerName: "Comment 2 Date",
      width: width / 12,
    },
    {
      field: "comment3",
      headerName: "TL Comment 3",
      width: (width / 12) * 3,
    },
    {
      field: "comment3_date",
      headerName: "Comment 3 Date",
      width: width / 12,
    },
  ];

  const qecolumns = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Cust Name",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },

    {
      field: "quote_id",
      headerName: "Quote Id",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },

    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: width / 12,
    },
    {
      field: "trip_status",
      headerName: "Trip Status",
      width: width / 12,
    },
    {
      field: "total",
      headerName: "Total",
      width: width / 12,
    },
    {
      field: "created_date",
      headerName: "CreatedAt",
      width: width / 12,
    },
    {
      field: "comment1",
      headerName: "TL Comment 1",
      width: (width / 12) * 3,
    },
    {
      field: "comment1_date",
      headerName: "Comment 1 Date",
      width: width / 12,
    },
    {
      field: "comment2",
      headerName: "TL Comment 2",
      width: (width / 12) * 3,
    },
    {
      field: "comment2_date",
      headerName: "Comment 2 Date",
      width: width / 12,
    },
    {
      field: "comment3",
      headerName: "TL Comment 3",
      width: (width / 12) * 3,
    },
    {
      field: "comment3_date",
      headerName: "Comment 3 Date",
      width: width / 12,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: width / 12,
    },
  ];

  const getEmployees = async () => {
    try {
      // const data = await fetchEmployees();
      setemp(employeelist);
      seteData(
        employeelist.filter((emp) => emp.role == "TL" || emp.role == "SME"),
      );
      setopsData(
        employeelist.filter(
          (emp) => emp.role == "Operations-TL" || emp.role == "Operations",
        ),
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!loading) {
      getEmployees();
    }
  }, [loading, cuser, role, employeelist, destinationlist]);

  const handleconvsearch = async () => {
    if (
      role == "Admin" ||
      role == "Product" ||
      role == "Operations-TL" ||
      cuser == "Kaushal" ||
      cuser == "Tarun" ||
      role == "Manager"
    ) {
      const data = await fetchConvertedTripsOnly();
      const temp = data.data.filter(
        (t) =>
          "booking" in t &&
          "transfer_state" in t.booking &&
          !(
            t.booking.transfer_state == "Accepted" ||
            t.booking.transfer_state == "Back to Sales"
          ) &&
          t.on_hold !== true &&
          new Date(getconvdate(t)).getTime() < new Date(DateCalc(0)).getTime(),
      );
      setconvdata(temp);
      console.log(temp);
    } else {
      const data = await fetchConvertedTripsbyTL(cuser);
      const temp = data.data.filter(
        (t) =>
          "booking" in t &&
          "transfer_state" in t.booking &&
          t.booking.transfer_state !== "Accepted" &&
          t.on_hold !== true &&
          new Date(getconvdate(t)).getTime() < new Date(DateCalc(0)).getTime(),
      );
      setconvdata(temp);
      console.log(temp);
    }
  };

  const updateflight = async () => {
    console.log(selection);
    var str = "";
    var tripid = tripdatalistdisplay[selection[0]].trip_id;
    console.log(tripid);
    var comment = prompt(
      "Press 1 for flight booked by customer, press 2 for flight booked by Jeto, press 3 for flight booking pending on customer, press 4 for flight booking pending on Jeto",
    );
    if (comment == 1) {
      str = "flight booked by customer";
      await updateTripflightdata({ flight_status: str, trip_id: tripid });
    } else if (comment == 2) {
      str = "flight booked by Jeto";
      await updateTripflightdata({ flight_status: str, trip_id: tripid });
    } else if (comment == 3) {
      str = "flight booking pending on customer";
      await updateTripflightdata({ flight_status: str, trip_id: tripid });
    } else if (comment == 4) {
      str = "flight booking pending on Jeto";
      await updateTripflightdata({ flight_status: str, trip_id: tripid });
    } else {
      alert("Wrong entry-try again");
    }
  };

  var l1 = [...convdata];
  if (filterData.tl) {
    const temp = emp.filter((e) => e.reporting_manager == filterData.tl);
    //console.log(temp)
    const temp2 = temp.map((e) => e.short_name);
    //console.log(temp2)
    l1 = l1.filter((trip) => temp2.includes(trip.trip_owner));
    //console.log(l1)
  }
  if (filterData.fy == "Yes") {
    l1 = l1.filter(
      (trip) =>
        new Date(trip.converted_date).getTime() >
        new Date("2026-04-01").getTime(),
    );
    //console.log(l1)
  }
  if (filterData.fy == "No") {
    l1 = l1.filter(
      (trip) =>
        new Date(trip.converted_date).getTime() <
        new Date("2026-04-01").getTime(),
    );
    //console.log(l1)
  }
  if (filterData.ops) {
    l1 = l1.filter(
      (trip) =>
        "booking" in trip && trip.booking.ops_assigned == filterData.ops,
    );
  }
  if (filterData.state) {
    l1 = l1.filter(
      (trip) =>
        "booking" in trip && trip.booking.transfer_state == filterData.state,
    );
  }

  const tripdatalistdisplay = l1.map((trip) => ({
    id: l1.indexOf(trip),
    trip_id: trip.trip_id,
    cust_name: trip.cust_name,
    trip_owner: trip.trip_owner,
    createdAt: trip.createdAt,
    trip_start_date: trip.trip_start_date,
    transfer_state: trip.booking.transfer_state,
    tcs: trip.tcs_mail,
    flight_status: trip.new_flight_status,
    comment1:
      "tl_comment" in trip &&
      trip.tl_comment.length > 0 &&
      trip.tl_comment[trip.tl_comment.length - 1].status == "Converted"
        ? trip.tl_comment[trip.tl_comment.length - 1].comment
        : "",
    comment1_date:
      "tl_comment" in trip &&
      trip.tl_comment.length > 0 &&
      trip.tl_comment[trip.tl_comment.length - 1].status == "Converted"
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 1].comment_date,
          ).toLocaleString("en-IN")
        : "",
    comment2:
      "tl_comment" in trip &&
      trip.tl_comment.length > 1 &&
      trip.tl_comment[trip.tl_comment.length - 2].status == "Converted"
        ? trip.tl_comment[trip.tl_comment.length - 2].comment
        : "",
    comment2_date:
      "tl_comment" in trip &&
      trip.tl_comment.length > 1 &&
      trip.tl_comment[trip.tl_comment.length - 2].status == "Converted"
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 2].comment_date,
          ).toLocaleString("en-IN")
        : "",
    comment3:
      "tl_comment" in trip &&
      trip.tl_comment.length > 2 &&
      trip.tl_comment[trip.tl_comment.length - 3].status == "Converted"
        ? trip.tl_comment[trip.tl_comment.length - 3].comment
        : "",
    comment3_date:
      "tl_comment" in trip &&
      trip.tl_comment.length > 2 &&
      trip.tl_comment[trip.tl_comment.length - 3].status == "Converted"
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 3].comment_date,
          ).toLocaleString("en-IN")
        : "",
    jc_date: trip.jc_date,
    accepted_date: trip.accepted_date,
  }));

  const gridcellclick = (id) => {
    window.open("/tripdataentry/" + id, "_blank");
  };

  const gridcellquoteclick = (id) => {
    window.open("/quotedataentry/" + id, "_blank");
  };

  const handlehotsearch = async () => {
    if (role == "Admin" || role == "Product" || role == "Manager") {
      const data = await fetchTripsbyStatus("Hot");
      const temp = data.data.filter(
        (t) =>
          new Date(gethotdate(t)).getTime() < new Date(DateCalc(0)).getTime(),
      );
      sethotdata(temp);
      console.log(data.data);
    } else {
      const data = await fetchhottripsTL(cuser);

      sethotdata(data.data);
      console.log(data.data);
    }
  };

   const handleholdopssearch = async () => {
   
      const data = await fetchbyholdops();
      sethodata(data.data);
      console.log(data.data);
    
  };

  var l2 = [...hotdata];
  if (filterData.tl) {
    const temp = emp.filter((e) => e.reporting_manager == filterData.tl);
    //console.log(temp)
    const temp26 = temp.map((e) => e.short_name);
    //console.log(temp2)
    l2 = l2.filter((trip) => temp26.includes(trip.trip_owner));
    //console.log(l1)
  }

  const tripdatalistdisplay2 = l2.map((trip) => ({
    id: l2.indexOf(trip),
    trip_id: trip.trip_id,
    cust_name: trip.cust_name,
    trip_owner: trip.trip_owner,
    trip_start_date: trip.trip_start_date,
    createdAt: trip.createdAt,
    hot_date: gethotdate(trip),
    pax:
      "number_child" in trip
        ? trip.number_adults + trip.number_child
        : trip.number_adults,
    verified: trip.hot_verified_by,
    comment1:
      "tl_comment" in trip && trip.tl_comment.length > 0
        ? trip.tl_comment[trip.tl_comment.length - 1].commenter +
          " - " +
          trip.tl_comment[trip.tl_comment.length - 1].comment
        : "",
    comment1_date:
      "tl_comment" in trip && trip.tl_comment.length > 0
        ? new Date(trip.tl_comment[trip.tl_comment.length - 1].comment_date).toLocaleString("en-IN")
        : "",
    comment1_date_calc:
      "tl_comment" in trip && trip.tl_comment.length > 0
        ? new Date(trip.tl_comment[trip.tl_comment.length - 1].comment_date)
        : "",
    comment2:
      "tl_comment" in trip && trip.tl_comment.length > 1
        ? trip.tl_comment[trip.tl_comment.length - 2].commenter +
          " - " +
          trip.tl_comment[trip.tl_comment.length - 2].comment
        : "",
    comment2_date:
      "tl_comment" in trip && trip.tl_comment.length > 1
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 2].comment_date,
          ).toLocaleString("en-IN")
        : "",
      comment2_date_calc:
      "tl_comment" in trip && trip.tl_comment.length > 1
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 2].comment_date,
          )
        : "",
    comment3:
      "tl_comment" in trip && trip.tl_comment.length > 2
        ? trip.tl_comment[trip.tl_comment.length - 3].commenter +
          " - " +
          trip.tl_comment[trip.tl_comment.length - 3].comment
        : "",
    comment3_date:
      "tl_comment" in trip && trip.tl_comment.length > 2
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 3].comment_date,
          ).toLocaleString("en-IN")
        : "",
    comment3_date_calc:
      "tl_comment" in trip && trip.tl_comment.length > 2
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 3].comment_date,
          )
        : "",
    dest: trip.primary_destination,
  }));

  const verifyhot = async () => {
    const tripid = tripdatalistdisplay2[selection2[0]].trip_id;
    console.log(tripid);
    const data = await fetchTripbyId(tripid);
    console.log(data.data);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      hot_verified_by: cuser,
    });
  };

  const updatecomment = async () => {
    var temparr = [...hotdata];
    const tripid = tripdatalistdisplay2[selection2[0]].trip_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "Hot",
      commenter: cuser,
    };
    temparr = temparr.map((trip) =>
      trip.trip_id == tripdatalistdisplay2[selection2[0]].trip_id
        ? { ...trip, tl_comment: [...trip.tl_comment, temp] }
        : trip,
    );
    sethotdata(temparr);
    const data = await fetchTripbyId(tripid);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
  };

  const updateexpertcomment = async () => {
    const tripid = tripdatalistdisplay2[selection2[0]].trip_id;
    var commenter = prompt("Enter new expert name:");
    var comment = prompt("Enter new expert comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "Expert",
      commenter: commenter,
    };
    const data = await fetchTripbyId(tripid);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
  };

  const handleprofittripsearch = async () => {
    const data = await gethighprofitsearch();

    const temp = data.data.filter((data) => data.profit > 50000);
    console.log(temp);
    setprofittrips(temp);
  };

  const updatecomment2 = async () => {
    var arr = [...bookerdata];
    const tripid = tripdatalistdisplay3[selection3[0]].trip_id;
    //console.log(arr)
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "Active",
    };
    arr = arr.map((trip) =>
      trip.trip_id == tripdatalistdisplay3[selection3[0]].trip_id
        ? {
            ...trip,
            comment3: trip.comment2,
            comment3_date: trip.comment2_date,
            comment2: trip.comment1,
            comment2_date: trip.comment1_date,
            comment1: comment,
            comment1_date: new Date(),
          }
        : trip,
    );
    setbookerdata(arr);
    //console.log(arr)
    const data = await fetchTripbyId(tripid);
    //console.log(data.data)
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    //console.log(data2.data)
  };

  const updatecomment3 = async () => {
    var temparr = [...convdata];
    var tripid = tripdatalistdisplay[selection[0]].trip_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "Converted",
    };
    temparr = temparr.map((trip) =>
      trip.trip_id == tripdatalistdisplay[selection[0]].trip_id
        ? { ...trip, tl_comment: [...trip.tl_comment, temp] }
        : trip,
    );
    setconvdata(temparr);
    const data = await fetchTripbyId(tripid);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
  };

  const updatecomment4 = async () => {
    var temparr = [...profittrips];
    console.log(selection4[0]);
    console.log(tripdatalistdisplay4[selection4[0]]);
    var qid = tripdatalistdisplay4[selection4[0]].quote_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "Profittrip",
    };
    temparr = temparr.map((trip) =>
      trip.trip_id == tripdatalistdisplay4[selection4[0]].trip_id
        ? { ...trip, tl_comment: [...trip.tl_comment, temp] }
        : trip,
    );
    setprofittrips(temparr);
    const data = await fetchQuotebyId(qid);
    const data2 = await updatequoteData(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    //console.log(data2.data)
  };

  const updatecomment5 = async () => {
    var temparr = [...luxurytrip];
    //console.log(selection5[0])
    // console.log(tripdatalistdisplay6[selection5[0]])
    var qid = tripdatalistdisplay6[selection5[0]].quote_id;
    console.log(qid);
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "Luxury quote",
    };
    temparr = temparr.map((trip) =>
      trip.trip_id == tripdatalistdisplay6[selection5[0]].trip_id
        ? { ...trip, tl_comment: [...trip.tl_comment, temp] }
        : trip,
    );
    setluxurytrip(temparr);
    const data = await fetchQuotebyId(qid);
    const data2 = await updatequoteData(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    //console.log(data2.data)
  };

  const updatecomment6 = async () => {
    var temparr = [...listQEdata];
    var qid = tripdatalistdisplay8[selection6[0]].quote_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "QE",
    };
    temparr = temparr.map((trip) =>
      trip.quote_id == tripdatalistdisplay8[selection6[0]].quote_id
        ? { ...trip, tl_comment: [...trip.tl_comment, temp] }
        : trip,
    );
    setlistQEdata(temparr);
    const data = await fetchQuotebyId(qid);
    const data2 = await updatequoteData(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    //console.log(data2.data)
  };

  const updatecomment9 = async () => {
     var temparr = [...hodata];
    console.log(selection8[0]);
    console.log(tripdatalistdisplay9[selection8[0]]);
    var tripid = tripdatalistdisplay9[selection8[0]].trip_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "HO",
    };
    temparr = temparr.map((trip) =>
      trip.trip_id == tripdatalistdisplay9[selection8[0]].trip_id
        ? { ...trip, tl_comment: [...trip.tl_comment, temp] }
        : trip,
    );
    sethodata(temparr)
    const data = await fetchTripbyId(tripid);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    //console.log(data2.data)
  };

  const superhot = async () => {
    const arr = selection2.map((number) =>
      Number(tripdatalistdisplay2[number].trip_id),
    );
    console.log(arr);
    const data = await updatesuperhot(arr);
    if (data.status == 200 || 201 || 202 || 203 || 204 || 205 || 206 || 207) {
      alert("Data updated ");
    } else {
      alert("Something went wrong. Contact support");
    }
  };

  const handlebookersearch = async () => {
    let sd = new Date(DateCalc(-3));
    let sd2 = new Date(DateCalc(-1));
    let ed = new Date(DateCalc(1));
    var temp = [];
    if (role == "Admin" || role == "Product" || role == "Manager") {
      const data = await fetchbookertripsTL1("Abhishek", sd, ed);
      const data2 = await fetchbookertripsTL2("Abhishek", sd, ed);
      const data3 = await fetchbookertripsTL3("Abhishek", sd, ed);
      const data6 = await fetchbookertripsTL6("Abhishek", sd2, ed);
      temp = [...data.data, ...data2.data, ...data3.data, ...data6.data];
      temp = removeDuplicates(temp, "trip_id");
      setbookerdata(temp);

      const data4 = await fetchbookertripsTL4("Abhishek", sd2, ed);
      //const data5=await fetchbookertripsTL5("Abhishek", sd, ed)
      temp = [...temp, ...data4.data];
      temp = removeDuplicates(temp, "trip_id");
      setbookerdata(temp);
      console.log(data.data);
    } else {
      const data = await fetchbookertripsTL1(cuser, sd, ed);
      const data2 = await fetchbookertripsTL2(cuser, sd, ed);
      const data3 = await fetchbookertripsTL3(cuser, sd, ed);
      const data6 = await fetchbookertripsTL6(cuser, sd2, ed);
      temp = [...data.data, ...data2.data, ...data3.data, ...data6.data];
      temp = removeDuplicates(temp, "trip_id");
      setbookerdata(temp);
      const data4 = await fetchbookertripsTL4(cuser, sd2, ed);
      //const data5=await fetchbookertripsTL5(cuser, sd, ed)
      temp = [...temp, ...data4.data];
      temp = removeDuplicates(temp, "trip_id");
      setbookerdata(temp);

      //setbookerdata(data.data)
      //console.log(data.data)
    }
  };

  const handleqesearch = async () => {
    try {
      var sd = DateCalc(-3);
      var ed = DateCalc(1);
      const data = await newsearchQEbyDate(sd, ed);
      console.log(data.data);
      var temp = data.data.filter(
        (q) =>
          !(
            q.trip_status == "Cancelled" ||
            q.trip_status == "Converted" ||
            q.trip_status == "Closed" ||
            q.trip_status == "Postponed"
          ),
      );
      const filtered = filterQuotes(temp);
      console.log(filtered);

      setlistQEdata(filtered);
    } catch (err) {
      console.log(err);
    }
  };

  const updateprojection = async () => {
    try {
      //console.log(new Date().getFullYear())
      const tripid = tripdatalistdisplay5[selection5[0]].trip_id;
      let p = prompt(
        "Enter when do you expect this trip to conver in number of days from today (e.g. enter 0 for today, 1 for tomorrow and so on)",
      );
      let temp = DateCalc(Number(p));
      //console.log(temp)
      const data = await fetchTripbyId(tripid);
      const data2 = await updateTripdata(data.data._id, {
        ...data.data,
        projection: [...data.data.projection, new Date(temp)],
      });
    } catch (e) {
      console.log(e);
    }
  };

  const getluxury = async () => {
    try {
      const data = await getactiveluxury();
      console.log(data.data);
      const temp = removeDuplicates(data.data, "trip_id");
      console.log(temp);
      setluxurytrip(temp);
    } catch (e) {
      console.log(e);
    }
  };

  var l3 = [...bookerdata];
  if (filterData.tl) {
    const temp = emp.filter((e) => e.reporting_manager == filterData.tl);
    //console.log(temp)
    const temp2 = temp.map((e) => e.short_name);
    //console.log(temp2)
    l3 = l3.filter((trip) => temp2.includes(trip.trip_owner));
    //console.log(l1)
  }

  const tripdatalistdisplay3 = l3.map((trip) => ({
    id: l3.indexOf(trip),
    trip_id: trip.trip_id,
    cust_name: trip.cust_name,
    trip_owner: trip.trip_owner,
    createdAt: trip.createdAt,
    trip_start_date: trip.start_date,
    why_hot: trip.why_hot,
    comment1: trip.comment1,
    comment2: trip.comment2,
    comment3: trip.comment3,
    comment1_date: new Date(trip.comment1_date).toLocaleString(),
    comment1_date_calc: trip.comment1_date,
    comment2_date: new Date(trip.comment2_date).toLocaleString(),
    comment2_date_calc: trip.comment2_date,
    comment3_date: new Date(trip.comment3_date).toLocaleString(),
    comment3_date_calc: trip.comment3_date,
  }));

  var l4 = [...profittrips];
  var l45 = [...luxurytrip];
  if (filterData.tl) {
    const temp = emp.filter((e) => e.reporting_manager == filterData.tl);
    console.log(temp);
    var temp25 = temp.map((e) => e.short_name);
    temp25 = [...temp25, filterData.tl];
    console.log(temp25);
    l4 = l4.filter((trip) => temp25.includes(trip.owner));

    l45 = l45.filter((trip) => temp25.includes(trip.trip_owner));
  }

  l4 = removeDuplicates(l4, "trip_id");
  l45 = removeDuplicates(l45, "trip_id");
  // console.log(l45)
  // console.log(l4)

  const tripdatalistdisplay4 = l4.map((trip) => ({
    id: l4.indexOf(trip),
    quote_id: trip.quote_id,
    trip_id: trip.trip_id,
    cust_name: trip.cust_name,
    createdAt: trip.createdAt,
    trip_owner: trip.owner,
    trip_start_date: trip.trip_start_date,
    primary_destination: trip.destination,
    profit: Math.round(trip.profit),
    comment1:
      "tl_comment" in trip &&
      trip.tl_comment.length > 0 &&
      trip.tl_comment[trip.tl_comment.length - 1].status == "Profittrip"
        ? trip.tl_comment[trip.tl_comment.length - 1].comment
        : "",
    comment1_date:
      "tl_comment" in trip &&
      trip.tl_comment.length > 0 &&
      trip.tl_comment[trip.tl_comment.length - 1].status == "Profittrip"
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 1].comment_date,
          ).toLocaleString("en-IN")
        : "",
    comment1_date_calc:
      "tl_comment" in trip &&
      trip.tl_comment.length > 0 &&
      trip.tl_comment[trip.tl_comment.length - 1].status == "Profittrip"
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 1].comment_date,
          )
        : "",
    comment2:
      "tl_comment" in trip &&
      trip.tl_comment.length > 1 &&
      trip.tl_comment[trip.tl_comment.length - 2].status == "Profittrip"
        ? trip.tl_comment[trip.tl_comment.length - 2].comment
        : "",
    comment2_date:
      "tl_comment" in trip &&
      trip.tl_comment.length > 1 &&
      trip.tl_comment[trip.tl_comment.length - 2].status == "Profittrip"
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 2].comment_date,
          ).toLocaleString("en-IN")
        : "",
     comment2_date_calc:
      "tl_comment" in trip &&
      trip.tl_comment.length > 1 &&
      trip.tl_comment[trip.tl_comment.length - 2].status == "Profittrip"
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 2].comment_date,
          )
        : "",
    comment3:
      "tl_comment" in trip &&
      trip.tl_comment.length > 2 &&
      trip.tl_comment[trip.tl_comment.length - 3].status == "Profittrip"
        ? trip.tl_comment[trip.tl_comment.length - 3].comment
        : "",
    comment3_date:
      "tl_comment" in trip &&
      trip.tl_comment.length > 2 &&
      trip.tl_comment[trip.tl_comment.length - 3].status == "Profittrip"
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 3].comment_date,
          ).toLocaleString("en-IN")
        : "",
    comment3_date_calc:
      "tl_comment" in trip &&
      trip.tl_comment.length > 2 &&
      trip.tl_comment[trip.tl_comment.length - 3].status == "Profittrip"
        ? new Date(
            trip.tl_comment[trip.tl_comment.length - 3].comment_date,
          )
        : "",
  }));

  const tripdatalistdisplay5 = hotdata.map((trip) => ({
    id: hotdata.indexOf(trip),
    trip_id: trip.trip_id,
    cust_name: trip.cust_name,
    trip_owner: trip.trip_owner,
    trip_start_date: trip.trip_start_date,
    hot_date: gethotdate(trip),
    verified: trip.hot_verified_by,
    createdAt: trip.createdAt,
    comment1:
      "projection" in trip && trip.projection.length > 0
        ? trip.projection[trip.projection.length - 1]
        : "",

    comment2:
      "projection" in trip && trip.projection.length > 1
        ? trip.projection[trip.projection.length - 2]
        : "",

    comment3:
      "projection" in trip && trip.projection.length > 2
        ? trip.projection[trip.projection.length - 3]
        : "",
  }));

  const tripdatalistdisplay6 = l45.map((q) => ({
    id: l45.indexOf(q),
    trip_id: q.trip_id,
    cust_name: q.cust_name,
    trip_owner: q.trip_owner,
    trip_start_date: q.trip_start_date,
    createdAt: q.createdAt,
    primary_destination: q.primary_destination,
    quote_id: q.quote_id,
    comment1:
      "tl_comment" in q &&
      q.tl_comment.length > 0 &&
      q.tl_comment[q.tl_comment.length - 1].status == "Luxury quote"
        ? q.tl_comment[q.tl_comment.length - 1].comment
        : "",
    comment1_date:
      "tl_comment" in q &&
      q.tl_comment.length > 0 &&
      q.tl_comment[q.tl_comment.length - 1].status == "Luxury quote"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 1].comment_date,
          ).toLocaleString("en-IN")
        : "",
    comment1_date_calc:
      "tl_comment" in q &&
      q.tl_comment.length > 0 &&
      q.tl_comment[q.tl_comment.length - 1].status == "Luxury quote"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 1].comment_date,
          )
        : "",
    comment2:
      "tl_comment" in q &&
      q.tl_comment.length > 1 &&
      q.tl_comment[q.tl_comment.length - 2].status == "Luxury quote"
        ? q.tl_comment[q.tl_comment.length - 2].comment
        : "",
    comment2_date:
      "tl_comment" in q &&
      q.tl_comment.length > 1 &&
      q.tl_comment[q.tl_comment.length - 2].status == "Luxury quote"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 2].comment_date,
          ).toLocaleString("en-IN")
        : "",
    comment2_date_calc:
      "tl_comment" in q &&
      q.tl_comment.length > 1 &&
      q.tl_comment[q.tl_comment.length - 2].status == "Luxury quote"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 2].comment_date,
          )
        : "",
    comment3:
      "tl_comment" in q &&
      q.tl_comment.length > 2 &&
      q.tl_comment[q.tl_comment.length - 3].status == "Luxury quote"
        ? q.tl_comment[q.tl_comment.length - 3].comment
        : "",
    comment3_date:
      "tl_comment" in q &&
      q.tl_comment.length > 2 &&
      q.tl_comment[q.tl_comment.length - 3].status == "Luxury quote"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 3].comment_date,
          ).toLocaleString("en-IN")
        : "",
       comment3_date_calc:
      "tl_comment" in q &&
      q.tl_comment.length > 2 &&
      q.tl_comment[q.tl_comment.length - 3].status == "Luxury quote"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 3].comment_date,
          )
        : "",
  }));

  const tripdatalistdisplay7 = projectionData.map((q) => ({
    id: projectionData.indexOf(q),
    trip_id:
      "projection" in q && "trip_id" in q.projection
        ? q.projection.trip_id
        : "",
    expected_date:
      "projection" in q && "expected_date" in q.projection
        ? q.projection.expected_date
        : "",
    tl_note:
      "projection" in q && "tl_note" in q.projection
        ? q.projection.tl_note
        : "",
    sp_name: "sp_name" in q ? q.sp_name : "",
    report_date: "report_date" in q ? q.report_date : "",
    trip_status: q.trip_status,
  }));

  var l44 = [...listQEdata];
  var l55 = [...hodata];
  if (filterData.tl) {
    const temp = emp.filter((e) => e.reporting_manager == filterData.tl);
    console.log(temp);
    var temp24 = temp.map((e) => e.short_name);
    temp24 = [...temp24, filterData.tl];
    console.log(temp24);
    l44 = l44.filter((trip) => temp24.includes(trip.trip_owner));
    console.log(l44);
    l55=l55.filter(t=>t.team_leader==filterData.tl)
  }

  const tripdatalistdisplay8 = l44.map((q) => ({
    id: l44.indexOf(q),
    trip_id: q.trip_id,
    quote_id: q.quote_id,
    cust_name: q.cust_name,
    trip_owner: q.trip_owner,
    created_date: q.createdAt,
    total: q.quote_price.total,
    trip_start_date: q.trip_start_date,
    trip_status: q.trip_status,
    comment1:
      "tl_comment" in q &&
      q.tl_comment.length > 0 &&
      q.tl_comment[q.tl_comment.length - 1].status == "QE"
        ? q.tl_comment[q.tl_comment.length - 1].comment
        : "",
    comment1_date:
      "tl_comment" in q &&
      q.tl_comment.length > 0 &&
      q.tl_comment[q.tl_comment.length - 1].status == "QE"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 1].comment_date,
          ).toLocaleString()
        : "",
         comment1_date_calc:
      "tl_comment" in q &&
      q.tl_comment.length > 0 &&
      q.tl_comment[q.tl_comment.length - 1].status == "QE"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 1].comment_date,
          )
        : "",
    comment2:
      "tl_comment" in q &&
      q.tl_comment.length > 1 &&
      q.tl_comment[q.tl_comment.length - 2].status == "QE"
        ? q.tl_comment[q.tl_comment.length - 2].comment
        : "",
    comment2_date:
      "tl_comment" in q &&
      q.tl_comment.length > 1 &&
      q.tl_comment[q.tl_comment.length - 2].status == "QE"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 2].comment_date,
          ).toLocaleString("en-IN")
        : "",
        comment2_date_calc:
      "tl_comment" in q &&
      q.tl_comment.length > 1 &&
      q.tl_comment[q.tl_comment.length - 2].status == "QE"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 2].comment_date,
          )
        : "",
    comment3:
      "tl_comment" in q &&
      q.tl_comment.length > 2 &&
      q.tl_comment[q.tl_comment.length - 3].status == "QE"
        ? q.tl_comment[q.tl_comment.length - 3].comment
        : "",
    comment3_date:
      "tl_comment" in q &&
      q.tl_comment.length > 2 &&
      q.tl_comment[q.tl_comment.length - 3].status == "QE"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 3].comment_date,
          ).toLocaleString("en-IN")
        : "",
     comment3_date_calc:
      "tl_comment" in q &&
      q.tl_comment.length > 2 &&
      q.tl_comment[q.tl_comment.length - 3].status == "QE"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 3].comment_date,
          )
        : "",
    dest: q.primary_destination,
  }));

   

    const tripdatalistdisplay9 = l55.map((q) => ({
    id: l55.indexOf(q),
    trip_id: q.trip_id,
    cust_name: q.cust_name,
    trip_owner: q.trip_owner,
    trip_start_date: q.trip_start_date,
    team_leader: q.team_leader,
    comment1:
      "tl_comment" in q &&
      q.tl_comment.length > 0 &&
      q.tl_comment[q.tl_comment.length - 1].status == "HO"
        ? q.tl_comment[q.tl_comment.length - 1].comment
        : "",
    comment1_date:
      "tl_comment" in q &&
      q.tl_comment.length > 0 &&
      q.tl_comment[q.tl_comment.length - 1].status == "HO"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 1].comment_date,
          ).toLocaleString("en-IN")
        : "",
    comment1_date_calc:
      "tl_comment" in q &&
      q.tl_comment.length > 0 &&
      q.tl_comment[q.tl_comment.length - 1].status == "HO"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 1].comment_date,
          )
        : "",
    comment2:
      "tl_comment" in q &&
      q.tl_comment.length > 1 &&
      q.tl_comment[q.tl_comment.length - 2].status == "HO"
        ? q.tl_comment[q.tl_comment.length - 2].comment
        : "",
    comment2_date:
      "tl_comment" in q &&
      q.tl_comment.length > 1 &&
      q.tl_comment[q.tl_comment.length - 2].status == "HO"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 2].comment_date,
          ).toLocaleString("en-IN")
        : "",
      comment2_date_calc:
      "tl_comment" in q &&
      q.tl_comment.length > 1 &&
      q.tl_comment[q.tl_comment.length - 2].status == "HO"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 2].comment_date,
          )
        : "",
    comment3:
      "tl_comment" in q &&
      q.tl_comment.length > 2 &&
      q.tl_comment[q.tl_comment.length - 3].status == "HO"
        ? q.tl_comment[q.tl_comment.length - 3].comment
        : "",
    comment3_date:
      "tl_comment" in q &&
      q.tl_comment.length > 2 &&
      q.tl_comment[q.tl_comment.length - 3].status == "HO"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 3].comment_date,
          ).toLocaleString("en-IN")
        : "",
      comment3_date_calc:
      "tl_comment" in q &&
      q.tl_comment.length > 2 &&
      q.tl_comment[q.tl_comment.length - 3].status == "HO"
        ? new Date(
            q.tl_comment[q.tl_comment.length - 3].comment_date,
          )
        : "",
    dest: q.primary_destination,
  }));

  const tlreportsearch = async () => {
    try {
      const data = await gettlreport(searchData.start_date);
      //console.log(data.data)
      setreportData(data.data);
      const data2 = await gethottrips();
      sethotlist(data2.data);
      //console.log(data2.data)
    } catch (e) {
      console.log(e);
    }
  };

  const openreport = async (tl) => {
    setopen(true);
    const empdata = emp.filter(
      (e) =>
        e.reporting_manager == tl && (e.role == "Sales" || e.role == "SME"),
    );
    const empdata2 = empdata.map((e) => e.short_name);
    setsplist(empdata2);
    var temp2 = reportData.filter((r) => "name" in r && r.name == tl);
    if (temp2.length > 0) {
      settlData(temp2[0]);
    } else {
      var temp = { name: tl, report: [] };
      for (let i = 0; i < empdata2.length; i++) {
        temp = { ...temp, report: [...temp.report, { sp_name: empdata2[i] }] };
      }
      //console.log(temp)
      settlData(temp);
    }
  };

  //console.log(tlData)
  const submitreport = async () => {
    try {
      if (reportData.filter((rep) => rep.name == tlData.name).length > 0) {
        const data = await updatetlreport(tlData);
        if (
          data.status == 200 ||
          data.status == 201 ||
          data.status == 202 ||
          data.status == 203 ||
          data.status == 204 ||
          data.status == 205 ||
          data.status == 206 ||
          data.status == 207
        ) {
          alert("Report updated successfully");
          setopen(false);
        } else {
          alert("Error in updating report. Try again");
        }
      } else {
        const data = await addtlreport({ ...tlData, report_date: new Date() });
        if (
          data.status == 200 ||
          data.status == 201 ||
          data.status == 202 ||
          data.status == 203 ||
          data.status == 204 ||
          data.status == 205 ||
          data.status == 206 ||
          data.status == 207
        ) {
          alert("Report saved successfully");
          setopen(false);
        } else {
          alert("Error in saving report. Try again");
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const changetldata = (field, value, sp) => {
    var temp = tlData.report.filter((d) => d.sp_name == sp);
    //console.log(temp)
    if (temp.length > 0) {
      settlData({
        ...tlData,
        report: tlData.report.map((d) =>
          d.sp_name == sp ? { ...d, [field]: value } : d,
        ),
      });
    }
  };

  const getavvalue = (field, sp) => {
    var temp = tlData.report.filter((d) => d.sp_name == sp);
    //console.log(temp)
    if (temp.length > 0) {
      return temp[0][field];
    } else {
      return "";
    }
  };

  const addp = (sp) => {
    var temp = tlData.report.filter((d) => d.sp_name == sp);
    var newproj =
      "projections" in temp[0] && temp[0].projections.length > 0
        ? [...temp[0].projections, { trip_id: "", tl_note: "" }]
        : [{ trip_id: "", tl_note: "" }];
    var newtemp = { ...temp[0], projections: newproj };
    settlData({
      ...tlData,
      report: tlData.report.map((d) => (d.sp_name == sp ? newtemp : d)),
    });
  };

  const removep = (sp) => {
    var temp = tlData.report.filter((d) => d.sp_name == sp);
    var newproj =
      "projections" in temp[0] && temp[0].projections.length > 0
        ? temp[0].projections.slice(0, -1)
        : [];
    var newtemp = { ...temp[0], projections: newproj };
    settlData({
      ...tlData,
      report: tlData.report.map((d) => (d.sp_name == sp ? newtemp : d)),
    });
  };

  const changetldata2 = (field, value, sp, index) => {
    //console.log(field, value, sp, index)
    var temp = tlData.report.filter((d) => d.sp_name == sp);
    //console.log(temp[0])
    var newproj = temp[0].projections.map((p) =>
      temp[0].projections.indexOf(p) == index ? { ...p, [field]: value } : p,
    );
    //console.log(newproj)
    var newtemp = { ...temp[0], projections: newproj };
    //console.log(newtemp)
    settlData({
      ...tlData,
      report: tlData.report.map((d) => (d.sp_name == sp ? newtemp : d)),
    });
  };

  const getprojection = async () => {
    try {
      if (searchData2.start_date && searchData2.end_date) {
        const data = await getprojectionfromserver(
          searchData2.start_date,
          searchData2.end_date,
        );
        console.log(data.data);

        const temp = data.data.map((p) =>
          "projection" in p && "trip_id" in p.projection
            ? p.projection.trip_id.split("-").slice(0, 1)[0]
            : "",
        );
        const temp2 = temp.filter((data) => data !== "");
        //console.log(temp2)
        const tripData = await fetchtripstatusoftripids(temp2);
        console.log(tripData.data);
        if (data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            var tripid = data.data[i].projection.trip_id
              .split("-")
              .slice(0, 1)[0];
            var status = tripData.data.filter((t) => t.trip_id == tripid);
            if (status.length > 0) {
              data.data[i].trip_status = status[0].trip_status;
            }
          }
        }
        setprojectionData(data.data);
      } else {
        alert("Enter dates and try again");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getcoverage = (arr) => {
    //console.log(arr)
    const data = arr.filter(
      (t) =>
        new Date(t.comment1_date_calc).getTime() > new Date(DateCalc(-4)).getTime(),
    );
    //console.log(data)
    const data2 = arr.filter(
      (t) => new Date(t.createdAt).getTime() > new Date(DateCalc(-4)).getTime(),
    );
    //console.log(data2)
    return (
      Math.round((data.length / arr.length) * 100) +
      "% updated in the last 4 days"
    );
  };

  const wareportsearch = async () => {
    const data = await getWAdata();
    console.log(data.data)
    var wadata2=[]
    for(let i=0;i<data.data.length;i++){
     
      const temp={
        id:i,
        employee_name:data.data[i].name,
        count:data.data[i].wa_report.report_check_count,
        manager:data.data[i].wa_report.entered_by,
        note: data.data[i].wa_report.report_note,
        date: data.data[i].wa_report.report_date,
      }
      wadata2=[...wadata2, temp]
    
    }
    console.log(wadata2)
    setwareportData(wadata2);
  };
  //console.log(wareportData)
  const wareportadd = async () => {
    //console.log(waData);
    const data = await addWAreport({ ...waData, entered_by: cuser });
    if (data.status == 200 || 201 || 202 || 203 || 204 || 205 || 206 || 207) {
      alert("Report succesfully added");
      setopen2(false)
      setwaData({})
    } else {
      alert("Something went wrong. Contact support");
    }
  };
  //console.log(selection5)
  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="xl"
        open={open}
        onClose={() => setopen(false)}
      >
        {splist && splist.length > 0 ? (
          <div>
            {tlData &&
              "report" in tlData &&
              tlData.report.length > 0 &&
              tlData.report.map((sp) => {
                return (
                  <div>
                    <Typography
                      variant="h6"
                      align="center"
                      className={classes.headertext}
                    >
                      {sp.sp_name}
                    </Typography>
                    <FormGroup row className={classes.formgroup}>
                      <FormControl
                        style={{
                          minWidth: 180,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="Duration">SP Available?</InputLabel>
                        <Select
                          displayEmpty
                          classname={classes.textField}
                          labelId="Duration"
                          value={
                            tlData && "report" in tlData
                              ? getavvalue("availability", sp.sp_name)
                              : ""
                          }
                          onChange={(e) =>
                            changetldata(
                              "availability",
                              e.target.value,
                              sp.sp_name,
                            )
                          }
                        >
                          <MenuItem value={"No"}>No</MenuItem>
                          <MenuItem value={"Yes"}>Yes</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 180,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="Duration2"># Effective FC</InputLabel>
                        <Select
                          displayEmpty
                          classname={classes.textField}
                          labelId="Duration2"
                          value={
                            tlData && "report" in tlData
                              ? getavvalue("effective_calls", sp.sp_name)
                              : ""
                          }
                          onChange={(e) =>
                            changetldata(
                              "effective_calls",
                              e.target.value,
                              sp.sp_name,
                            )
                          }
                        >
                          <MenuItem value={0}>0</MenuItem>
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={6}>6</MenuItem>
                          <MenuItem value={7}>7</MenuItem>
                          <MenuItem value={8}>8</MenuItem>
                          <MenuItem value={9}>9</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                        </Select>
                      </FormControl>
                    </FormGroup>
                    {"projections" in sp &&
                      sp.projections.length > 0 &&
                      sp.projections.map((proj) => {
                        return (
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 180,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Duration">Trip Id?</InputLabel>
                              <Select
                                displayEmpty
                                classname={classes.textField}
                                labelId="Duration"
                                value={proj.trip_id}
                                onChange={(e) =>
                                  changetldata2(
                                    "trip_id",
                                    e.target.value,
                                    sp.sp_name,
                                    sp.projections.indexOf(proj),
                                  )
                                }
                              >
                                {hotlist.length > 0 &&
                                  hotlist
                                    .filter(
                                      (trip) => trip.trip_owner == sp.sp_name,
                                    )
                                    .map((h) => {
                                      return (
                                        <MenuItem
                                          value={
                                            h.trip_id +
                                            "-" +
                                            h.cust_name +
                                            "-" +
                                            h.trip_owner
                                          }
                                        >
                                          {h.trip_id +
                                            "-" +
                                            h.cust_name +
                                            "-" +
                                            h.trip_owner}
                                        </MenuItem>
                                      );
                                    })}
                              </Select>
                            </FormControl>
                            <TextField
                              variant="outlined"
                              type="date"
                              label="Expected Date"
                              value={
                                "expected_date" in proj
                                  ? proj.expected_date.split("T").slice(0, 1)
                                  : ""
                              }
                              className={classes.textField2}
                              InputLabelProps={{ shrink: true }}
                              onChange={(e) =>
                                changetldata2(
                                  "expected_date",
                                  e.target.value,
                                  sp.sp_name,
                                  sp.projections.indexOf(proj),
                                )
                              }
                            />
                            <TextField
                              variant="outlined"
                              label="TL Notes"
                              value={proj.tl_note}
                              className={classes.textField}
                              InputLabelProps={{ shrink: true }}
                              onChange={(e) =>
                                changetldata2(
                                  "tl_note",
                                  e.target.value,
                                  sp.sp_name,
                                  sp.projections.indexOf(proj),
                                )
                              }
                            />
                          </FormGroup>
                        );
                      })}

                    <FormGroup row className={classes.formgroup}>
                      <Button
                        variant="outlined"
                        color="primary"
                        className={classes.button}
                        onClick={() => addp(sp.sp_name)}
                      >
                        {" "}
                        + Projection
                      </Button>
                      <Button
                        variant="outlined"
                        color="secondary"
                        className={classes.button}
                        onClick={() => removep(sp.sp_name)}
                      >
                        {" "}
                        - Projection
                      </Button>
                    </FormGroup>
                  </div>
                );
              })}
          </div>
        ) : (
          "No sales person found under tl"
        )}
        <br></br>
        <br></br>
        <div align="center">
          <Button
            variant="contained"
            color="primary"
            onClick={preventDoubleClick(submitreport)}
            className={classes.button}
          >
            Save
          </Button>
        </div>
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="xl"
        open={open2}
        onClose={() => setopen2(false)}
      >
        <Typography variant="h4" align="center" className={classes.headertext}>
          Enter Data
        </Typography>
        <FormGroup row className={classes.formgroup}>
          <TextField
            variant="standard"
            type="date"
            label={"Report Date"}
            InputLabelProps={{ shrink: true }}
            className={classes.textField3}
            onChange={(e) =>
              setwaData({ ...waData, report_date: new Date(e.target.value) })
            }
          />
          <FormControl
            style={{
              minWidth: 450,
              marginTop: 16,
              marginRight: 24,
              marginLeft: 5,
            }}
          >
            <InputLabel id="Sales Person">Sales Person</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Sales Person"
              value={waData.trip_owner}
              onChange={(e) =>
                setwaData({ ...waData, report_sp: e.target.value })
              }
            >
              {emp &&
                emp
                  .filter((e) => e.role == "Sales" || e.role == "SME")
                  .map((emp) => {
                    return (
                      <MenuItem value={emp.short_name}>
                        {emp.short_name}
                      </MenuItem>
                    );
                  })}
            </Select>
          </FormControl>
          <TextField
            variant="standard"
            label={"Report Count"}
            InputLabelProps={{ shrink: true }}
            value={waData.report_check_count}
            className={classes.textField3}
            onChange={(e) =>
              setwaData({
                ...waData,
                report_check_count: e.target.value,
              })
            }
          />
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
          <TextField
            variant="outlined"
            label={
              "report_note" in waData && waData.report_note
                ? "Observations - " + waData.report_note.length
                : "Observations"
            }
            InputLabelProps={{ shrink: true }}
            value={waData.report_note}
            className={classes.textArea}
            fullWidth
            onChange={(e) =>
              setwaData({ ...waData, report_note: e.target.value })
            }
          />
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
          <Button
            onClick={preventDoubleClick(wareportadd)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Save
          </Button>
        </FormGroup>
      </Dialog>
      {/*<Paper variant="outlined" className={classes.paper} elevation={10}>
       <Typography variant="h4" align="center" className={classes.headertext}> TL Daily Report</Typography>
       <div align="center">
         <TextField
                   variant="outlined"
                   type="date"
                   label="Report On"
                   className={classes.textField}
                   InputLabelProps={{ shrink: true }}
                   onChange={(e) =>
                     setsearchData({ ...searchData, start_date: e.target.value })
                   }
                 />
              
                 <Button
                   onClick={preventDoubleClick(tlreportsearch)}
                   color="secondary"
                   variant="contained"
                   className={classes.button}
                 >
                   Search
                 </Button>
                 </div>
                 {reportData && eData && eData.length>0 && eData.map(tl=>{return(
                  <Table>
                    <TableRow>
                      <TableCell>{tl.short_name}</TableCell>
                      <TableCell><div align="right"><button onClick={preventDoubleClick((()=>openreport(tl.short_name)))}>{reportData.filter(rep=>rep.name==tl.short_name).length>0?"Edit Report":"Submit Report"}</button></div></TableCell>
                    </TableRow>
                  </Table>
                 )})}
                 
    </Paper>*/}
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          Whatsapp Check
        </Typography>
        <div align="center">
          <Button
            onClick={preventDoubleClick(wareportsearch)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          <Button
            onClick={() => setopen2(true)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Add
          </Button>
        </div>

        {wareportData.length > 0 ? (
          <div style={{ height: 1000, width: "100%" }}>
            <DataGrid
              rows={wareportData}
              disableColumnResize={false}
              columns={wacolumns}
              pageSize={20}
            ></DataGrid>
            {/* <AgGridReact rowData={tripdatalistdisplay2} columnDefs={fcolumns2} /> */}
          </div>
        ) : (
          ""
        )}
      </Paper>
      <br></br>
      <br></br>
      <br></br>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <div align="center">
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            View Requested Trips
          </Typography>
          <div align="center">
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="tl">TL</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="tl"
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setfilterData({ ...filterData, tl: e.target.value })
                }
              >
                <MenuItem value={""}>Clear</MenuItem>
                {eData.map((emp) => {
                  return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="tl">Ops Status</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="tl"
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setfilterData({ ...filterData, state: e.target.value })
                }
              >
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Accepted"}>{"Accepted"}</MenuItem>
                <MenuItem value={"Requested"}>{"Requested"}</MenuItem>
                <MenuItem value={"Back to Sales"}>{"Back to Sales"}</MenuItem>
                <MenuItem value={"Just Converted"}>{"Just Converted"}</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="tl">Ops Owner</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="ops"
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setfilterData({ ...filterData, ops: e.target.value })
                }
              >
                <MenuItem value={""}>Clear</MenuItem>
                {opsData.map((emp) => {
                  return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="fy">FY 2026-27</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="tl"
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setfilterData({ ...filterData, fy: e.target.value })
                }
              >
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
              </Select>
            </FormControl>
          </div>
           <FormGroup row className={classes.formgroup}>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(() => handleconvsearch(cuser))}
          >
            Load
          </Button>
          {selection.length > 0 ? (
            <div>
              <Button
                variant="contained"
                color="Inherit"
                className={classes.button}
                onClick={preventDoubleClick(() => updateflight(cuser))}
              >
                Flight
              </Button>
              <Button
                variant="contained"
                color="Inherit"
                className={classes.button}
                onClick={() => updatecomment3()}
              >
                Comment
              </Button>
            </div>
          ) : (
            ""
          )}
          </FormGroup>
        </div>

        {tripdatalistdisplay.length > 0 ? (
          <div style={{ height: 1000, width: "100%" }}>
            <DataGrid
              rows={tripdatalistdisplay}
              onCellDoubleClick={(getValue) =>
                gridcellclick(getValue.row.trip_id)
              }
              columns={fcolumns}
              checkboxSelection={true}
              onSelectionModelChange={(newSelection) => {
                setselection(newSelection);
              }}
              pageSize={15}
            ></DataGrid>
          </div>
        ) : (
          ""
        )}
      </Paper>
      <br></br>
      <br></br>
      <br></br>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <div align="center">
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            View Hot Trips
          </Typography>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {tripdatalistdisplay2.length > 0
              ? getcoverage(tripdatalistdisplay2)
              : ""}
          </Typography>
           <FormGroup row className={classes.formgroup}>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(() => handlehotsearch(cuser))}
          >
            Load
          </Button>
          {selection2.length > 0 ? (
            <div>
              <Button
                variant="contained"
                color="Inherit"
                className={classes.button}
                onClick={() => updatecomment()}
              >
                Comment
              </Button>
              <Button
                variant="contained"
                color="Inherit"
                className={classes.button}
                onClick={() => updateexpertcomment()}
              >
                Expert Comment
              </Button>
              <Button
                variant="contained"
                color="Inherit"
                className={classes.button}
                onClick={() => verifyhot()}
              >
                Verify
              </Button>
              {role == "Admin" ? (
                <Button
                  variant="contained"
                  color="Inherit"
                  className={classes.button}
                  onClick={() => superhot()}
                >
                  Super Hot
                </Button>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          </FormGroup>
        </div>

        <div align="center">
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="tl">TL</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="tl"
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setfilterData({ ...filterData, tl: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              {eData.map((emp) => {
                return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </div>
        {tripdatalistdisplay2.length > 0 ? (
          <div>
            <CSVLink data={tripdatalistdisplay2} headers={headershot}>
              Download CSV
            </CSVLink>
          </div>
        ) : (
          ""
        )}
        {tripdatalistdisplay2.length > 0 ? (
          <div style={{ height: 1000, width: "100%" }}>
            <DataGrid
              rows={tripdatalistdisplay2}
              onCellDoubleClick={(getValue) =>
                gridcellclick(getValue.row.trip_id)
              }
              disableColumnResize={false}
              columns={fcolumns2}
              checkboxSelection={true}
              onSelectionModelChange={(newSelection) => {
                setselection2(newSelection);
              }}
              columnBuffer={2}
              pageSize={20}
            ></DataGrid>
            {/* <AgGridReact rowData={tripdatalistdisplay2} columnDefs={fcolumns2} /> */}
          </div>
        ) : (
          ""
        )}
      </Paper>
      <br></br>
      <br></br>
      <br></br>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <div align="center">
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            View Booker Trips
          </Typography>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {tripdatalistdisplay3.length > 0
              ? getcoverage(tripdatalistdisplay3)
              : ""}
          </Typography>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(() => handlebookersearch(cuser))}
          >
            Load
          </Button>
          {selection3.length > 0 ? (
            <Button
              variant="contained"
              color="Inherit"
              className={classes.button}
              onClick={() => updatecomment2()}
            >
              Comment
            </Button>
          ) : (
            ""
          )}
        </div>
        <div align="center">
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="tl">TL</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="tl"
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setfilterData({ ...filterData, tl: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              {eData.map((emp) => {
                return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </div>
        {tripdatalistdisplay3.length > 0 ? (
          <div>
            <CSVLink data={tripdatalistdisplay3} headers={headershot}>
              Download CSV
            </CSVLink>
          </div>
        ) : (
          ""
        )}
        {tripdatalistdisplay3.length > 0 ? (
          <div style={{ height: 1000, width: "100%" }}>
            <DataGrid
              rows={tripdatalistdisplay3}
              onCellDoubleClick={(getValue) =>
                gridcellclick(getValue.row.trip_id)
              }
              columns={fcolumns3}
              checkboxSelection={true}
              onSelectionModelChange={(newSelection) => {
                setselection3(newSelection);
              }}
              pageSize={20}
            ></DataGrid>
          </div>
        ) : (
          ""
        )}
      </Paper>
      <br></br>
      <br></br>
      <br></br>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <div align="center">
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            QE Trips
          </Typography>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {tripdatalistdisplay8.length > 0
              ? getcoverage(tripdatalistdisplay8)
              : ""}
          </Typography>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(() => handleqesearch())}
          >
            Load
          </Button>
          {selection6.length > 0 ? (
            <Button
              variant="contained"
              color="Inherit"
              className={classes.button}
              onClick={() => updatecomment6()}
            >
              Comment
            </Button>
          ) : (
            ""
          )}
        </div>
        <div align="center">
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="tl">TL</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="tl"
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setfilterData({ ...filterData, tl: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              {eData.map((emp) => {
                return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </div>
        {tripdatalistdisplay8.length > 0 ? (
          <div>
            <CSVLink data={tripdatalistdisplay8} headers={headersqe}>
              Download CSV
            </CSVLink>
          </div>
        ) : (
          ""
        )}
        {tripdatalistdisplay8.length > 0 ? (
          <div style={{ height: 1000, width: "100%" }}>
            <DataGrid
              rows={tripdatalistdisplay8}
              onCellDoubleClick={(getValue) =>
                gridcellquoteclick(getValue.row.quote_id)
              }
              columns={qecolumns}
              checkboxSelection={true}
              onSelectionModelChange={(newSelection) => {
                setselection6(newSelection);
              }}
              pageSize={20}
            ></DataGrid>
          </div>
        ) : (
          ""
        )}
      </Paper>
      <br></br>
      <br></br>
      <br></br>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <div align="center">
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            High Profit Trips
          </Typography>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {tripdatalistdisplay4.length > 0
              ? getcoverage(tripdatalistdisplay4)
              : ""}
          </Typography>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(() => handleprofittripsearch())}
          >
            Load
          </Button>
          {selection4.length > 0 ? (
            <Button
              variant="contained"
              color="Inherit"
              className={classes.button}
              onClick={() => updatecomment4()}
            >
              Comment
            </Button>
          ) : (
            ""
          )}
        </div>
        <div align="center">
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="tl">TL</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="tl"
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setfilterData({ ...filterData, tl: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              {eData.map((emp) => {
                return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </div>
        {tripdatalistdisplay4.length > 0 ? (
          <div>
            <CSVLink data={tripdatalistdisplay4} headers={headershigh}>
              Download CSV
            </CSVLink>
          </div>
        ) : (
          ""
        )}
        {tripdatalistdisplay4.length > 0 ? (
          <div style={{ height: 1000, width: "100%" }}>
            <DataGrid
              rows={tripdatalistdisplay4}
              onCellDoubleClick={(getValue) =>
                gridcellclick(getValue.row.trip_id)
              }
              columns={fcolumns4}
              checkboxSelection={true}
              onSelectionModelChange={(newSelection) => {
                setselection4(newSelection);
              }}
              pageSize={20}
            ></DataGrid>
          </div>
        ) : (
          ""
        )}
      </Paper>
      <br></br>
      <br></br>
      <br></br>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <div align="center">
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Luxury Quotes
          </Typography>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {tripdatalistdisplay6.length > 0
              ? getcoverage(tripdatalistdisplay6)
              : ""}
          </Typography>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(() => getluxury())}
          >
            Load
          </Button>
          {selection5.length > 0 ? (
            <Button
              variant="contained"
              color="Inherit"
              className={classes.button}
              onClick={() => updatecomment5()}
            >
              Comment
            </Button>
          ) : (
            ""
          )}
        </div>
        <div align="center">
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="tl">TL</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="tl"
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setfilterData({ ...filterData, tl: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              {eData.map((emp) => {
                return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </div>

        {tripdatalistdisplay6.length > 0 ? (
          <div style={{ height: 1000, width: "100%" }}>
            <DataGrid
              rows={tripdatalistdisplay6}
              onCellDoubleClick={(getValue) =>
                gridcellquoteclick(getValue.row.quote_id)
              }
              columns={fcolumns6}
              checkboxSelection={true}
              onSelectionModelChange={(newSelection) => {
                setselection5(newSelection);
              }}
              pageSize={20}
            ></DataGrid>
          </div>
        ) : (
          ""
        )}
      </Paper>
      <br></br>
      <br></br>
      <br></br>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <div align="center">
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
          On Hold Trips
          </Typography>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {tripdatalistdisplay9.length > 0
              ? getcoverage(tripdatalistdisplay9)
              : ""}
          </Typography>
          <FormGroup row className={classes.formgroup}>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(() => handleholdopssearch())}
          >
            Load
          </Button>
          {selection8.length > 0 ? (
            <div>
              <Button
                variant="contained"
                color="Inherit"
                className={classes.button}
                onClick={() => updatecomment9()}
              >
                Comment
              </Button>
             
            </div>
          ) : (
            ""
          )}
          </FormGroup>
        </div>

        <div align="center">
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="tl">TL</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="tl"
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setfilterData({ ...filterData, tl: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              {eData.map((emp) => {
                return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </div>
        {tripdatalistdisplay9.length > 0 ? (
          <div>
            <CSVLink data={tripdatalistdisplay9} headers={headersho}>
              Download CSV
            </CSVLink>
          </div>
        ) : (
          ""
        )}
        {tripdatalistdisplay9.length > 0 ? (
          <div style={{ height: 1000, width: "100%" }}>
            <DataGrid
              rows={tripdatalistdisplay9}
              onCellDoubleClick={(getValue) =>
                gridcellclick(getValue.row.trip_id)
              }
              disableColumnResize={false}
              columns={fcolumns9}
              checkboxSelection={true}
              onSelectionModelChange={(newSelection) => {
                setselection8(newSelection);
              }}
              columnBuffer={2}
              pageSize={20}
            ></DataGrid>
            {/* <AgGridReact rowData={tripdatalistdisplay2} columnDefs={fcolumns2} /> */}
          </div>
        ) : (
          ""
        )}
      </Paper>
      {/* <Paper variant="outlined" className={classes.paper} elevation={10}>
  <Typography variant="h4" align="center" className={classes.headertext}> View Projections</Typography>
  <div align="center">
       <TextField
                   variant="outlined"
                   type="date"
                   label="Start Date"
                   value={"start_date" in searchData2?searchData2.start_date:""}
                   className={classes.textField2}
                   InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                                    setsearchData2({...searchData2, start_date:e.target.value})
                                  }
                 />
      <TextField
                   variant="outlined"
                   type="date"
                   label="End Date"
                   value={"end_date" in searchData2?searchData2.end_date:""}
                   className={classes.textField2}
                   InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                                    setsearchData2({...searchData2, end_date:e.target.value})
                                  }
                 />
                 <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(()=>getprojection())}
          >
          Load
          </Button>
          </div>
           {tripdatalistdisplay7.length>0?(
             <div style={{ height: 1000, width: '100%' }}>
             <DataGrid
            rows={tripdatalistdisplay7}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id.split("-").slice(0,1))
            }
            disableColumnResize={false} 
            columns={fcolumns22}
           
           
            pageSize={20}
         
          ></DataGrid></div>):("")}
</Paper> */}
    </div>
  );
};

export default TLHome;
